__turbopack_context__.v({
  "loading": "spinner-module__ow5Bza__loading",
  "pulse": "spinner-module__ow5Bza__pulse",
  "simple_loading": "spinner-module__ow5Bza__simple_loading",
  "spin": "spinner-module__ow5Bza__spin",
});
